import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { Tooltip, OverlayTrigger  } from 'react-bootstrap'
import messages from './messages'

import AppTools from 'utils/app/appTools'
import APPURL from 'utils/app/urls'

import PanelRowContainer from 'modules/Charts/PanelRow/PanelRowContainer'
import IndicatorTools from 'utils/indicators/indicatorTools'

import Error from 'components/Error'
import Loading from 'components/Loading'

class PanelSection extends Component {
	constructor(props) {
		super(props)

		const {
			intl: { formatMessage }
		} = props
		this.formatMessage = formatMessage

		this.state = {
			loading: true,
			error: false,
			collapsed: this.props.collapsed,
			levelTitle: '',
			levelIndicators: []
		}
	}

	componentDidMount() {
		let levelIndicators = IndicatorTools.getIndicatorsFromLevel(this.props.dimension)

		this.setState({
			levelIndicators,
			loading: false
		})
	}

	toggleCollapse = () => {
		this.setState({
			collapsed: !this.state.collapsed
		})
	}

	composePanelRows = ( indicators ) => {
		let rows = [];

		for (let i = 0; i < indicators.length; i++) {
			rows.push(<PanelRowContainer key={indicators[i]} indicator={indicators[i]} />)
		}

		return rows;
	}

	renderPanelSubsection = ( dimension, subdimension, indicators ) => {
		let title = AppTools.getSubDimensionTitle( dimension, subdimension ); // `Subsection ${subdimension} title`;
		let rankingTooltip = <Tooltip id="tooltip">{this.formatMessage(messages.rankingTooltip)}</Tooltip>;

		let firstHeadColumns = subdimension === 0 ? <React.Fragment>
			<div className="row visible-lg">
				<div className="col-lg-8">
					<div className="row">
						<div className="col-lg-3 panel-slim-column">{this.formatMessage(messages.columnRegion)}</div>
						<div className="col-lg-3 panel-slim-column">{this.formatMessage(messages.columnCountry)}</div>
						<div className="col-lg-3 panel-slim-column" dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.columnEU) }} />
						<div className="col-lg-3 panel-slim-column">
							{this.formatMessage(messages.columnRanking)}
							<OverlayTrigger overlay={rankingTooltip}>
								<sup><a>*</a></sup>
							</OverlayTrigger>
						</div>
					</div>
				</div>
				<div className="col-lg-4">
					<div className="row">
						<div className="col-lg-2">{this.formatMessage(messages.columnEvolution)}</div>
					</div>
				</div>
			</div>
		</React.Fragment> : null;
		let key = `${dimension}.${subdimension}`;

		return <React.Fragment key={key}>
			<div className="row obs-panel-head">
                <div className="col-lg-6">{title}</div>
				<div className="col-lg-6">
					{firstHeadColumns}
				</div>
            </div>
			{this.composePanelRows( indicators )}
		</React.Fragment>
	}

	composePanelSubsections = (dimension) => {
		let subsections = [];

		this.state.levelIndicators.forEach( (subLevelIndicators, subLevel) => {
			subsections.push( this.renderPanelSubsection( dimension, subLevel, subLevelIndicators ) )
		} )
		return subsections;
	}

	renderPanelTable() {
		let title = AppTools.getDimensionTitle( this.props.dimension );
		let subtitle = AppTools.getDimensionSubtitle(this.props.dimension);
		let panelClass = `obs-panel-${this.props.dimension}`;

		let actualURL = this.props.history.location.pathname
		let dimensionLink = APPURL.getLevelDetailLink({ url: actualURL, level: this.props.dimension });
		let dimensionLinkTooltip = <Tooltip id="tooltip">
			<div dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.dimensionLinkTooltip, {dimensionTitle: title}) }} />
		</Tooltip>;

		return <React.Fragment>
			<div className={panelClass}>
				<h3>{title} &nbsp;
					<OverlayTrigger overlay={dimensionLinkTooltip}>
						<Link to={dimensionLink}>
							<i className="fal fa-search-plus" />
						</Link>
					</OverlayTrigger>
				</h3>
				<p>{subtitle}</p>
				{/* <table className="table table-striped table-obs-panel" width="100%">
					{this.composePanelSubsections(this.props.dimension)}
				</table> */}
				<div className='col-12 obs-panel'>
					{this.composePanelSubsections(this.props.dimension)}
				</div>
			</div>
		</React.Fragment>
	}

	renderIfAllOK() {
		let renderingComponent = null
		if (this.state.error) {
			renderingComponent = <Error />
		} else if (this.state.loading) {
			renderingComponent = <Loading />
		} else {
			renderingComponent = this.renderPanelTable()
		}

		return renderingComponent
	}

	render() {
		return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
	}
}

export default injectIntl(PanelSection)



// WEBPACK FOOTER //
// ./src/modules/Content/PanelSection/PanelSection.jsx